import { SET_DELETE_PROJECT } from "../../constants";

export const deleteProject = (DeleteProject: any = {}) => ({
  type: SET_DELETE_PROJECT,
  payload: DeleteProject,
});
